export const CHANGE_TOKEN_TYPE = "change_token"